import axiosHelper from "../../../../axiosHelper";
import { APIUSEROLD, API_FAILURE, GET_ALL_SUPPLIER } from "../../../../config/constants";
import { apiErrors } from "../../../../helper";
import Toaster from "../../../common/Toaster";
//Havells
export function getTypeEstablishment() {
  const request = axiosHelper.get(`${APIUSEROLD.getTypeOfEstablishment}`);
  return request
    .then((response) => {
      if (response.data.Result) {
        // You can perform additional actions if needed
      }
      return response?.data; // Return the response to the caller
    })
    .catch((error) => {
      if (error.response.status === 401) {
        apiErrors(error)
      } else {

        throw error; // Re-throw the error to the caller
      }
    });
}

export function getTyBuisness() {
  const request = axiosHelper.get(`${APIUSEROLD.getTypeOfBuisness}`);
  return request
    .then((response) => {
      if (response.data.Result) {
        // You can perform additional actions if needed
      }
      return response?.data; // Return the response to the caller
    })
    .catch((error) => {
      if (error.response.status === 401) {
        apiErrors(error)
      } else {

        throw error; // Re-throw the error to the caller
      }
    });
}
export function getSupplierSpecializationService(selectedBusinessTypeId) {
  const request = axiosHelper.post(
    `${APIUSEROLD.getSupplierSpecialization}`, {
    businessTypeId: selectedBusinessTypeId
  }
  );
  return request
    .then((response) => {
      if (response.data.Result) {
        // You can perform additional actions if needed
      }
      return response?.data; // Return the response to the caller
    })
    .catch((error) => {
      if (error.response.status === 401) {
        apiErrors(error)
      } else {

        throw error; // Re-throw the error to the caller
      }
    });
}
export function getYearOfBuisnessService() {
  const request = axiosHelper.get(`${APIUSEROLD.getYearOfBuisness}`);
  return request
    .then((response) => {
      if (response.data.Result) {
        // You can perform additional actions if needed
      }
      return response?.data; // Return the response to the caller
    })
    .catch((error) => {
      if (error.response.status === 401) {
        apiErrors(error)
      } else {

        throw error; // Re-throw the error to the caller
      }
    });
}
export function getRelationService() {
  const request = axiosHelper.get(`${APIUSEROLD.getRelationService}`);
  return request
    .then((response) => {
      if (response.data.Result) {
        // You can perform additional actions if needed
      }
      return response?.data; // Return the response to the caller
    })
    .catch((error) => {
      if (error.response.status === 401) {
        apiErrors(error)
      } else {

        throw error; // Re-throw the error to the caller
      }
    });
}
export function getCurrencyList() {
  const request = axiosHelper.get(`${APIUSEROLD.getCurrencyListService}`);
  return request
    .then((response) => {
      if (response.data.Result) {
        // You can perform additional actions if needed
      }
      return response?.data; // Return the response to the caller
    })
    .catch((error) => {
      if (error.response.status === 401) {
        apiErrors(error)
      } else {

        throw error; // Re-throw the error to the caller
      }
    });
}


export function getCurrencyScaleList(currencyId) {
  const request = axiosHelper.post(
    `${APIUSEROLD.getCurrencyListPostService}`, {
    currencyId
  }
  );
  return request
    .then((response) => {
      if (response.data.Result) {
        // You can perform additional actions if needed
      }
      return response?.data; // Return the response to the caller
    })
    .catch((error) => {
      if (error.response.status === 401) {
        apiErrors(error)
      } else {

        throw error; // Re-throw the error to the caller
      }
    });
}


export function getCountryService() {
  const request = axiosHelper.get(`${APIUSEROLD.getCountryService}`);
  return request
    .then((response) => {
      if (response.data.Result) {
        // You can perform additional actions if needed
      }
      return response?.data; // Return the response to the caller
    })
    .catch((error) => {
      if (error.response.status === 401) {
        apiErrors(error)
      } else {

        throw error; // Re-throw the error to the caller
      }
    });
}
export function getStateSelection(countryId) {
  const request = axiosHelper.post(
    `${APIUSEROLD.getStateService}`, {
    countryId
  }
  );
  return request
    .then((response) => {
      if (response.data.Result) {
        // You can perform additional actions if needed
      }
      return response?.data; // Return the response to the caller
    })
    .catch((error) => {
      if (error.response.status === 401) {
        apiErrors(error)
      } else {

        throw error; // Re-throw the error to the caller
      }
    });
}
export function getDistrictSelection(stateId) {
  const request = axiosHelper.post(
    `${APIUSEROLD.getDistrictService}`, {
    stateId
  }
  );
  return request
    .then((response) => {
      if (response.data.Result) {
        // You can perform additional actions if needed
      }
      return response?.data; // Return the response to the caller
    })
    .catch((error) => {
      if (error.response.status === 401) {
        apiErrors(error)
      } else {

        throw error; // Re-throw the error to the caller
      }
    });
}
export function getCitySelection(districtId) {
  const request = axiosHelper.post(
    `${APIUSEROLD.getCityService}`, {
    districtId
  }
  );
  return request
    .then((response) => {
      if (response.data.Result) {
        // You can perform additional actions if needed
      }
      return response?.data; // Return the response to the caller
    })
    .catch((error) => {
      if (error.response.status === 401) {
        apiErrors(error)
      } else {

        throw error; // Re-throw the error to the caller
      }
    });
}
export function getServiceHowDidYouHearAbout() {
  const request = axiosHelper.get(`${APIUSEROLD.getServiceHowDidYouHear}`);
  return request
    .then((response) => {
      if (response.data.Result) {
        // You can perform additional actions if needed
      }
      return response?.data; // Return the response to the caller
    })
    .catch((error) => {
      if (error.response.status === 401) {
        apiErrors(error)
      } else {

        throw error; // Re-throw the error to the caller
      }
    });
}




export function getSelectSupplierService() {
  const request = axiosHelper.get(`${APIUSEROLD.getSelectSupplierByVendor}`);
  return request
    .then((response) => {
      if (response.data.Result) {
        // You can perform additional actions if needed
      }
      return response?.data; // Return the response to the caller
    })
    .catch((error) => {
      if (error.response.status === 401) {
        apiErrors(error)
      } else {

        throw error; // Re-throw the error to the caller
      }
    });
}
export function getAllBlockReasonListService() {
  const request = axiosHelper.get(`${APIUSEROLD.getAllBlockReason}`);
  return request
    .then((response) => {
      if (response.data.Result) {
        // You can perform additional actions if needed
      }
      return response?.data; // Return the response to the caller
    })
    .catch((error) => {
      if (error.response.status === 401) {
        apiErrors(error)
      } else {

        throw error; // Re-throw the error to the caller
      }
    });
}


export function getSelectSupplierPlant() {
  const request = axiosHelper.get(`${APIUSEROLD.getPlantByVendorNeedForm}`);
  return request
    .then((response) => {
      return response?.data; // Return the response to the caller
    })
    .catch((error) => {
      if (error.response.status === 401) {
        apiErrors(error)
      } else {

        throw error; // Re-throw the error to the caller
      }
    });
}


export function getSelectSupplierCategoryService(IsExceptionalSupplier) {
  let endpoint = APIUSEROLD.getCategoryVendorNeedForm;
  if (IsExceptionalSupplier) {
    endpoint = `${endpoint}?IsExceptionalSupplier=${IsExceptionalSupplier}`
  }
  const request = axiosHelper.get(endpoint);
  return request
    .then((response) => {
      return response?.data; // Return the response to the caller
    })
    .catch((error) => {
      if (error.response.status === 401) {
        apiErrors(error)
      } else {

        throw error; // Re-throw the error to the caller
      }
    });
}

export function getAllSupplierSpecializationService() {
  const request = axiosHelper.get(`${APIUSEROLD.getAllSupplierSpecialization}`);
  return request
    .then((response) => {
      return response?.data; // Return the response to the caller
    })
    .catch((error) => {
      if (error.response.status === 401) {
        apiErrors(error)
      } else {

        throw error; // Re-throw the error to the caller
      }
    });
}
export function getPaymentTermsService() {
  const request = axiosHelper.get(`${APIUSEROLD.getPaymentTermsVendorNeed}`);
  return request
    .then((response) => {
      return response?.data; // Return the response to the caller
    })
    .catch((error) => {
      if (error.response.status === 401) {
        apiErrors(error)
      } else {

        throw error; // Re-throw the error to the caller
      }
    });
}

export function getSourceOfOrigin() {
  const request = axiosHelper.get(`${APIUSEROLD.getSourceOfOriginVendor}`);
  return request
    .then((response) => {
      return response?.data; // Return the response to the caller
    })
    .catch((error) => {
      if (error.response.status === 401) {
        apiErrors(error)
      } else {

        throw error; // Re-throw the error to the caller
      }
    });
}

export function getCommercialReasonService() {
  const request = axiosHelper.get(`${APIUSEROLD.getCommercialReasonService}`);
  return request
    .then((response) => {
      return response?.data; // Return the response to the caller
    })
    .catch((error) => {
      if (error.response.status === 401) {
        apiErrors(error)
      } else {

        throw error; // Re-throw the error to the caller
      }
    });
}
export function getDivisionByCategoryService(categoryId) {
  const request = axiosHelper.post(
    `${APIUSEROLD.getCategoryDivisionById}`, {
    CategoryId: categoryId
  }
  );
  return request
    .then((response) => {
      if (response.data.Result) {
        // You can perform additional actions if needed
      }
      return response?.data; // Return the response to the caller
    })
    .catch((error) => {
      
      // apiErrors(error);
      if (error.response.status === 401) {
        apiErrors(error)
      } else {

        throw error; // Re-throw the error to the caller
      }
    });
}
export function getUser(id) {
  const request = axiosHelper.get(`${APIUSEROLD.getUserByid}/${id}`);

  return request
    .then((response) => {
      if (response.data.Result) {
        // You can perform additional actions if needed
      }
      return response.data; // Return the response to the caller
    })
    .catch((error) => {
      if (error.response.status === 401) {
        apiErrors(error)
      } else {

        throw error; // Re-throw the error to the caller
      }

    });
}

export function addNewSupplierByHavells(data, callback) {
  return (dispatch) => {
    //dispatch({ type: API_REQUEST });
    const request = axiosHelper.post(APIUSEROLD.addNewSupplierByHavells, data)
    request
      .then((response) => {
        if (response.data) {
          callback(response?.data)
        }
      })
      .catch((error) => {
        dispatch({ type: API_FAILURE })
        if (error.response.status === 401) {
          apiErrors(error)
        } else {

          callback(error);
        }
        // apiErrors(error)
      })
  }
}



export function supplierListing(filter, callback) {
  return (dispatch) => {
    const request = axiosHelper.get(`${APIUSEROLD.getAllSupplierListing}`, {

      params: {
        page: filter.current_page,
        pageSize: filter.per_page,
        registrationType: 2

      }
      // Assuming filter contains necessary query parameters
    });
    request
      .then((response) => {
        if (response?.data || response.status === 204) {
          dispatch({
            type: GET_ALL_SUPPLIER,
            payload: {
              data: response.status === 204 ? [] : response?.data?.result,

              filter, // Include filter in payload
            },
          });
          callback(response, null);
        }
      })
      .catch((error) => {
        dispatch({ type: API_FAILURE });
        if (error.response.status === 401) {
          apiErrors(error)
        } else {

          callback(null, error);
        }
        // apiErrors(error);
      });
  };
}

export function saveNewSupplier(data, callback) {
  return (dispatch) => {
    //dispatch({ type: API_REQUEST });
    const request = axiosHelper.post(APIUSEROLD.saveVendorNeedForm, data)
    request
      .then((response) => {
        if (response.data) {
          callback(response?.data)
        }
      })
      .catch((error) => {

        if (error.response.status === 401) {
          apiErrors(error)
        } else {
          dispatch({ type: API_FAILURE })
          Toaster.error(error?.response?.data?.ErrorMessage)
          callback(error)
        }


        //  throw error;


      })
  }
}


export function saveNewBlockSupplier(data) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axiosHelper.post(APIUSEROLD.saveVendorNeedForm, data)
        .then((response) => {
          if (response.data) {
            resolve(response.data);
          } else {
            reject(new Error('No response data'));
          }
        })
        .catch((error) => {
          dispatch({ type: API_FAILURE });
          if (error.response.status === 401) {
            apiErrors(error)
          } else {
            Toaster.error(error?.response?.data?.ErrorMessage);
            reject(error);
          }
        });
    });
  };
}



// export async function getVendorRegistrationId(id: number): P1romise<any> {
//   const response = await axiosHelperInstance.get(`VendorNeedForm/GetVendorNeedFormDetailById?VendorRequirementRegistrationId=${id}`);
//   return response.data;
// }


export function getVendorRegistrationId(id) {
  const request = axiosHelper.get(`${APIUSEROLD.getVendorDetailById}=${id}`);

  return request
    .then((response) => {
      if (response.data.Result) {
        // You can perform additional actions if needed
      }
      return response.data; // Return the response to the caller
    })
    .catch((error) => {
      if (error.response.status === 401) {
        apiErrors(error)
      } else {
        throw error; // Re-throw the error to the caller
      }


    });
}